import { IUser } from 'stores/user/UserStore';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export { setWalkme, clearWalkMe };

function setWalkme(user?: IUser, version?: number, license?: any) {
    if (!window.walkMeData) window.walkMeData = {};

    if (user) {
        const {
            hashedEmail,
            email,
            roleMappings: [{ role: { name } } = {}]
        } = user;
        window.walkMeData.userId = email;
        window.walkMeData.role = name;
        window.walkMeData.emailAddress = hashedEmail;
    }

    if (version) {
        window.walkMeData.applicationVersionNumber = version;
    }

    if (license) {
        const { hasAvLicense, hasEdrLicense, tenantCreationDaysElapsed, customer, region, salesforceId, trialAccount } = license;
        window.walkMeData.subscriptionType = {
            dattoAv: hasAvLicense,
            dattoEdr: hasEdrLicense
        };
        window.walkMeData.resourceCreationDaysElapsed = tenantCreationDaysElapsed;
        window.walkMeData.companyName = customer;
        window.walkMeData.locale = region;
        window.walkMeData.isAccountTrial = trialAccount;
        window.walkMeData.salesforceId = salesforceId;
    }

    window.walkMeData.tenantId = window.location.hostname.split('.')[0];

    window.walkMeData.utcDate = dayjs.utc().format('YYYY-MM-DD');

    window.walkMeData.utcTime = dayjs.utc().format('HHmm');
}

function clearWalkMe() {
    delete window.walkMeData;
}
